const vn = {
    error1: 'Lỗi máy chủ, vui lòng thử lại',
    error1_1: 'Lỗi nội bộ máy chủ, vui lòng thử lại sau',
    error1_2: 'Máy chủ không hỗ trợ yêu cầu, vui lòng thử lại sau',
    error1_3: 'Máy chủ không khả dụng, vui lòng thử lại sau',
    error1_4: 'Server Gateway Timeout Vui lòng thử lại sau',
    error1_5: 'Máy chủ không hỗ trợ phiên bản HTTP, vui lòng thử lại sau',
    error2: 'Cần chuyển dữ liệu yêu cầu',
    error3: 'Lỗi tham số',
    error4: 'Cơ sở dữ liệu chưa được khởi tạo',
    error5: 'Lỗi kiểu enum',
    error6: 'Lỗi truyền tham số',
    error7: 'token bị thiếu hoặc token đã hết hạn',
    error8: 'preUpload.Id không tồn tại',
    error9: 'fileInfo.Id không tồn tại',
    error10: 'Chỉ mục tệp đã tồn tại',
    error11: 'Thiếu tập tin part',
    error12: 'Không tìm thấy tập tin tương ứng',
    error13: 'Admin quyền không cho phép sửa đổi',
    error14: 'Làm mới token không tồn tại',
    error15: 'Không tìm thấy dữ liệu tương ứng',
    error16: 'Không tìm thấy số điện thoại di động',
    error17: 'Số điện thoại di động này đã tồn tại',
    error18: 'Tên đăng nhập hoặc mật khẩu không chính xác',
    error19: 'Nhiều nhân viên không tồn tại',
    error20: 'Không tìm thấy tổ chức',
    error21: 'Nhân viên đã tồn tại trong tổ chức',
    error22: 'Tổ chức đang kiểm kê',
    error23: 'Nhật ký không tồn tại',
    error24: 'Doc không tồn tại',
    error25: 'Loại sản phẩm không tồn tại',
    error26: 'Sản phẩm không tồn tại',
    error27: 'Quét không tồn tại',
    error28: 'Nhiều lần quét không tồn tại',
    error29: 'Mã vạch đã tồn tại cho lần quét này',
    error30: 'Không tìm thấy dữ liệu đơn hàng đi/đến',
    error31: 'Thiếu hàng tồn kho',
    error32: 'Không tìm thấy bảng kiểm kê',
    error33: 'Mặt hàng tồn kho không tồn tại',
    error34: 'Mã hóa đã tồn tại, không được thêm nhiều lần!',
    error35: 'Lỗi mạng, hãy thử lại sau khi kiểm tra kết nối mạng của bạn.',
    error36: 'Yêu cầu thời gian chờ, vui lòng thử lại.',
    error37: 'Mã hóa loại hàng hóa lặp lại.',
    error38: 'Không có dữ liệu hàng hóa và dữ liệu mã vạch trong phiếu quét dẫn đến việc không thể xuất/nhập kho, sắp đóng trang.',
    error39: 'Không đủ hàng tồn kho',
    error40: 'Đơn xuất vượt không tồn tại',
    error41: 'Trạng thái đơn không cho phép thao tác này',
    error42: 'Chi tiết yêu cầu không hợp lệ hoặc không khớp',
    error43: 'Số lượng xuất vượt phải lớn hơn 0',
    error44: 'Chi tiết xuất vượt đã tạo đơn xuất kho',
    error45: 'Mã khách hàng đã tồn tại',
    error46: 'Không tìm thấy địa chỉ giao hàng',
    error47: 'Tên người nhận đã tồn tại',
    error48: 'Không tìm thấy thiết bị',
    error49: 'Trạng thái hiện tại của thiết bị không cho phép thao tác này',
    error50: 'Thiết bị không ở trong kho nên không thể mượn',
    error51: 'Thiết bị không được sử dụng nên không thể trả',
    error52: 'Thiết bị đã có lượt mượn chưa được trả',
    error53: 'Loại bản ghi này phải sử dụng API chuyên dụng',
    error54: 'Thiết bị đã bị thanh lý',
    error55: 'Chuyển đổi trạng thái thiết bị không hợp lệ',
    error56: 'Cấu hình bảo trì không hợp lệ',
    error57: 'Mã tài sản đã tồn tại',
    error58: 'Không tìm thấy bản ghi thiết bị',
    error59: 'Mã danh mục thiết bị đã tồn tại',
    error60: 'Không tìm thấy danh mục thiết bị',
    error61: 'Danh mục cha chưa được bật nên không thể bật danh mục con',
    error62: 'Danh mục có danh mục con nên không thể xóa',
    error63: 'Danh mục đã được sử dụng nên không thể sửa mã hoặc tên',
    error64: 'Bộ phận bảo quản là bắt buộc',
    error65: 'Thiết bị chỉ có thể liên kết với danh mục lá',
    error66: "Thao tác đang xếp hàng chờ thực hiện, vui lòng thử lại sau",
};

export default vn;
